import React from "react";
import _ from "lodash";
import SimpleTooltip from "./SimpleTooltip";
import {
  JSON_ERROR_MSG,
  JSON_VALID_MSG,
  stringifyJson,
  checkIsValidJson,
} from "helpers/JsonCheck";

import { FiXCircle, FiCheckCircle } from "react-icons/fi";

class TextAreaWithJsonCheck extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: this.props.inputValue || "",
      errMsg: null,
      validMsg: null,
    };

    this.handleInputChanged = this.handleInputChanged.bind(this);
    this.handleJsonCheck = this.handleJsonCheck.bind(this);
    this.handleBeautifyJson = this.handleBeautifyJson.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.inputValue !== this.props.inputValue) {
      this.setState({ inputValue: this.props.inputValue });
    }
  }

  handleInputChanged(e) {
    const inputValue = e.target.value;
    this.setState({ inputValue, errMsg: null, validMsg: null });

    this.props.handleInputChanged(inputValue);
  }

  handleJsonCheck() {
    const { inputValue } = this.state;

    const jsonData = checkIsValidJson(inputValue);
    let errMsg = null;
    let validMsg = null;
    if (_.isNil(jsonData)) {
      errMsg = JSON_ERROR_MSG;
    } else {
      validMsg = JSON_VALID_MSG;
    }

    this.setState(
      {
        errMsg,
        validMsg,
      },
      () => {
        // [Check procedure] return the result is valid or invalid.
        if (this.props.onSyncErrMsg) {
          this.props.onSyncErrMsg(errMsg);
        }
      }
    );
  }

  handleBeautifyJson() {
    const { inputValue } = this.state;

    const jsonData = checkIsValidJson(inputValue);
    let errMsg = null;
    if (_.isNil(jsonData)) {
      errMsg = "Not a valid JSON";
    } else {
      this.setState({
        inputValue: stringifyJson(jsonData),
      });
    }

    this.setState(
      {
        errMsg,
      },
      () => {
        // [Reformat procedure] return the error message if the JSON is invalid.
        if (this.props.onSyncErrMsg && errMsg) {
          this.props.onSyncErrMsg(errMsg);
        }
      }
    );
  }

  render() {
    // const { handleInputChanged, inputValue } = this.props;
    const { rows, iconOnly = false, onSyncErrMsg } = this.props;
    const { inputValue, errMsg, validMsg } = this.state;

    return (
      <>
        <textarea
          rows={rows || 10}
          className="border rounded w-full border-gray-400 p-2"
          value={inputValue}
          // onChange={(e) => this.handleInputChanged("layers", e.target.value)}
          onChange={this.handleInputChanged}
        ></textarea>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={this.handleBeautifyJson}
            className="rounded shadow bg-white px-4 py-2 text-gray-800 hover:bg-gray-100"
          >
            Beautify JSON
          </button>
          <button
            type="button"
            onClick={this.handleJsonCheck}
            className="rounded shadow bg-white px-4 py-2 text-gray-800 hover:bg-gray-100"
          >
            Check JSON format
          </button>
          {!onSyncErrMsg && iconOnly && (
            <SimpleTooltip
              tooltipText={errMsg || validMsg || ""}
              position="top"
            >
              {errMsg && <FiXCircle className="text-lg text-red-600" />}
              {validMsg && <FiCheckCircle className="text-lg text-green-600" />}
            </SimpleTooltip>
          )}
        </div>

        {!onSyncErrMsg && !iconOnly && (
          <>
            {errMsg && (
              <div className="bg-red-100 px-4 py-2 text-red-600">{errMsg}</div>
            )}
            {validMsg && (
              <div className="bg-green-100 px-4 py-2 text-green-600">
                {validMsg}
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

export default TextAreaWithJsonCheck;
